// import constants
import { PAGES, PAGE_IDS } from 'js/constants/Pages';

import { APP_START_FRONTEND, APP_PAGES_DATA, APP_DATA, APP_PREVIEW_MODE } from 'js/store/app/App.actions.js';

// Import Parser
import { parseMetaData } from 'js/store/app/parser/Matadata.parser';
import { parseHomepageData } from 'js/store/app/parser/Homepage.parser';
import { parseAboutData } from 'js/store/app/parser/About.parser';
import { parseVisionAndValuesData } from 'js/store/app/parser/VisionAndValues.parser';
import { parseNavigation } from 'js/store/app/parser/Navigation.parser';
import { parseMakesData } from 'js/store/app/parser/Makes.parser';
import { parseWatchData } from 'js/store/app/parser/Watch.parser';
import { parseGamesData } from 'js/store/app/parser/Games.parser';

const initState = {
  startFrontend: false,
  pagesData: {},
  meta: {},
  navigation: [],
  social: [],
  previewMode: false,
};

const app = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case APP_START_FRONTEND:
      nextState.startFrontend = true;
      return { ...state, ...nextState };

    case APP_PAGES_DATA:
      nextState.pagesData = {
        [PAGE_IDS.home]: parseHomepageData(action.payload.homepage),
        [PAGE_IDS.vision_and_values]: parseVisionAndValuesData(action.payload.vision_and_values),
        [PAGE_IDS.characters]: action.payload.characters,
        [PAGE_IDS.explore_porthole]: action.payload.explore_porthole,
        [PAGE_IDS.about]: parseAboutData(action.payload.about),
        [PAGE_IDS.terms]: action.payload.terms,
        [PAGE_IDS.cookie_policy]: action.payload.cookie_policy,
        [PAGE_IDS.privacy_policy]: action.payload.privacy_policy,
        [PAGE_IDS.make]: parseMakesData(action.payload.make),
        [PAGE_IDS.watch]: parseWatchData(action.payload.watch),
        [PAGE_IDS.games]: parseGamesData(action.payload.games),
      };
      return { ...state, ...nextState };

    case APP_DATA:
      nextState.meta = parseMetaData(action.payload.meta);
      nextState.navigation = parseNavigation(action.payload.navigation);
      nextState.social = action.payload.social;

      return { ...state, ...nextState };

    case APP_PREVIEW_MODE:
      nextState.previewMode = action.payload.preview || false;

      return { ...state, ...nextState };
  }
  return state;
};

export default app;
